import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated/app/contactos")({
  beforeLoad: () => {
    throw redirect({ to: "/app/leads" });
  },
});
